// extracted by mini-css-extract-plugin
export default {"summary":"Summary_summary__P3lUb"};